import { useFeatureFlagEnabled } from '@frameio/feature-flags';
import { useFeatureGatePlanSuggestion } from '@frameio/plan-management/feature-gate/hooks';

export function useIsNLPEnabled(): boolean {
  const nlpSuggestion = useFeatureGatePlanSuggestion('NATURAL_LANGUAGE_SEARCH');
  const isFlagEnabled = useFeatureFlagEnabled('v4.search.enable_nlp');
  // If either NLP feature gate is false, NLP Search related UI will not render
  // and GraphQL calls will be skipped
  return Boolean(nlpSuggestion?.includedInCurrentPlan && isFlagEnabled);
}
